import { useEffect, useState } from "react";
import moment from "moment";

const formatCountdown = (startDate, now) => {
    if (!startDate) return null;
    const diff = moment(startDate).diff(moment(now));
    if (diff <= 0) return null;
    const d = moment.duration(diff);
    const days = String(Math.floor(d.asDays())).padStart(2, "0");
    const hrs = String(d.hours()).padStart(2, "0");
    const mins = String(d.minutes()).padStart(2, "0");
    return `${days}d : ${hrs}h : ${mins}m`;
};

const useCountdownText = (startDate, tickMs = 60 * 1000) => {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), tickMs);
        return () => clearInterval(timer);
    }, [tickMs]);

    return formatCountdown(startDate, now);
};

export default useCountdownText;
